(function() {

	var defaultSpeed = 2500;

	function showNextSlide(slides, /* current index*/i) {
		slides[i].classList.remove('active');
		i++;

		if (i >= slides.length) {
			i = 0;
		}

		slides[i].classList.add('active');
		return i;
	}

	Array.from(document.querySelectorAll('.teaser-slider-image-holder')).forEach( function(slider) {
		// values for each slider

		var i = 0;
		var dataSpeed = parseInt(slider.dataset.speed, 10);
		var speed = (dataSpeed && dataSpeed>0) ? dataSpeed : defaultSpeed;
		var slides = slider.querySelectorAll('.teaser-slider-image-item');

		if(!slides.length) {
			return;
		}

		setInterval(function() {
			requestAnimationFrame(function() {
				i = showNextSlide(slides, i);
			});
		}, speed);
	});


}());
